<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('remark')"
      prop="remark"
      :rules="getValidationRule('required,minLength')"
      class="material-style">
      <el-input
        ref="firstField"
        :value="form.remark"
        @input="form.remark = valueTrimLeft($event)"
        @change="updateModelItem('remark', { required: true })"/>
    </el-form-item>
    <el-form-item
      :label="L10n('sales-remark-index')"
      prop="salesRemarkIndex"
      class="material-style">
      <el-input
        ref="secondField"
        :value="form.salesRemarkIndex"
        @input="form.salesRemarkIndex = valueTrimLeft($event)"
        @change="updateModelItem('salesRemarkIndex')"/>
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormStockSalesRemarks',
  mixins: [Form]
}
</script>
